export const MY_REWARDS_APP_DEF_ID = '16ed1ac6-01cb-4fb6-a59e-c215cce8fdf6';
export const MY_REWARDS_WIDGET_ID = 'c85a2896-9f7c-4cf1-9bf8-95852cc5219a';
export const MY_REWARDS_SECTION_ID = 'My Rewards';
